/** Book an order. Nothing is written, and no order number spent, until Save. */
import { ORDER_TYPES } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import {
  NewOrderTypeStep,
  OrderPage,
} from "@/features/sales-dispatch/components/order-page";

export const Route = createFileRoute("/_app/orders/new")({
  validateSearch: z.object({
    type: z.enum(ORDER_TYPES).optional(),
  }),
  beforeLoad: () => {
    if (!useAuth.getState().can("orders.book"))
      throw redirect({ to: "/orders" });
  },
  component: Page,
});

function Page() {
  const { type } = Route.useSearch();
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  if (!type) return <NewOrderTypeStep />;
  return (
    <OrderPage
      key={type}
      order={null}
      orderType={type}
      facilityId={selected?.id}
    />
  );
}
